@if (isOpen) {
<div class="settings-modal-backdrop" (click)="onClose()"></div>
<div class="settings-modal-wrapper">
  <div class="settings-modal-card" (click)="$event.stopPropagation()">
    <div class="settings-modal-header">
      <div class="settings-modal-title-group">
        <span class="settings-modal-icon">
          <span class="material-symbols-outlined">settings</span>
        </span>
        <h2 class="settings-modal-title">Settings</h2>
      </div>
      <button type="button" class="settings-modal-close" (click)="onClose()" aria-label="Close settings">
        <span class="material-symbols-outlined">close</span>
      </button>
    </div>

    <div class="settings-modal-body">
      <div class="settings-tabs">
        @for (tab of tabs; track tab.id) {
        <button type="button" class="settings-tab" [class.active]="activeTab === tab.id" (click)="selectTab(tab.id)">
          <span class="material-symbols-outlined">{{ tab.icon }}</span>
          <span>{{ tab.label }}</span>
        </button>
        }
      </div>

      <div class="settings-content">
        @if (activeTab === 'sound') {
        <div class="settings-section">
          <h3 class="settings-section-title">Notifications on this device</h3>
          <p class="settings-section-desc">Switch a family off to stop its notifications here (phone and desktop each keep their own settings), and give each one its own chime so you know what arrived without looking.</p>

          @for (k of soundService.kinds; track k.id) {
          <div class="sound-setting-card" [class.off]="!soundService.isEnabled(k.id)">
            <div class="sound-setting-row">
              <div class="sound-setting-icon" [style.background]="k.gradient">
                <span class="material-symbols-outlined">{{ k.icon }}</span>
              </div>
              <div class="sound-setting-info">
                <div class="sound-setting-title-wrap">
                  <span class="sound-setting-label">{{ k.label }}</span>
                </div>
                <span class="sound-setting-desc">{{ k.desc }}</span>
              </div>
              <div class="sound-setting-actions">
                <button type="button" class="sound-chime-btn" (click)="toggleKindOpen(k.id)" [disabled]="!soundService.isEnabled(k.id)" [title]="'Chime for ' + k.label">
                  <span class="material-symbols-outlined">{{ soundService.isMuted(k.id) ? 'volume_off' : 'music_note' }}</span>
                  <span>{{ currentSoundLabel(k.id) }}</span>
                  <span class="material-symbols-outlined caret">{{ openKind === k.id ? 'expand_less' : 'expand_more' }}</span>
                </button>
                <button type="button" class="sound-toggle" [class.on]="soundService.isEnabled(k.id)"
                  (click)="toggleEnabled(k.id)" [attr.aria-pressed]="soundService.isEnabled(k.id)"
                  [title]="soundService.isEnabled(k.id) ? 'Turn ' + k.label + ' notifications off on this device' : 'Turn ' + k.label + ' notifications on'">
                  <span class="sound-toggle-thumb">
                    <span class="material-symbols-outlined">{{ soundService.isEnabled(k.id) ? 'notifications_active' : 'notifications_off' }}</span>
                  </span>
                </button>
              </div>
            </div>
            @if (openKind === k.id && soundService.isEnabled(k.id)) {
            <div class="sound-card-footer">
              <div class="sound-options">
                <button type="button" class="sound-option" [class.selected]="soundService.isMuted(k.id)" (click)="selectSound(k.id, '')">
                  <span class="material-symbols-outlined">volume_off</span>
                  <span class="sound-option-label">No sound</span>
                  @if (soundService.isMuted(k.id)) { <span class="material-symbols-outlined sound-option-check">check</span> }
                </button>
                @for (o of soundService.soundOptions; track o.id) {
                <button type="button" class="sound-option" [class.selected]="!soundService.isMuted(k.id) && soundService.soundIdOf(k.id) === o.id" (click)="selectSound(k.id, o.id)">
                  <span class="material-symbols-outlined sound-option-play" (click)="previewOption(o.id, k.id, $event)" [title]="'Play ' + o.label">{{ soundService.isPlaying(o.id, k.id) ? 'stop_circle' : 'play_circle' }}</span>
                  <span class="sound-option-label">{{ o.label }}</span>
                  @if (!soundService.isMuted(k.id) && soundService.soundIdOf(k.id) === o.id) { <span class="material-symbols-outlined sound-option-check">check</span> }
                </button>
                }
              </div>
            </div>
            }
          </div>
          }
        </div>
        }
      </div>
    </div>
  </div>
</div>
}